import OrganizationForm from '../../components/OrganizationForm/OrganizationForm';
import { UPDATE_ORGANIZATION } from '../../constants';

function OrganizationEdit() {
  return <OrganizationForm type={UPDATE_ORGANIZATION} />;
}

export default OrganizationEdit;
